document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pw-features]').forEach((wrap) => {
    const btn = wrap.querySelector('.pw-features-toggle');
    const panel = wrap.querySelector('.pw-features-panel');
    if (!btn || !panel) return;

    // Safety: ensure it starts closed
    btn.setAttribute('aria-expanded', 'false');
    panel.hidden = true;

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });
  });
});

